import { useSetRecoilState } from 'recoil'

import { appAlertMessageStore } from './appAlertMessageStore'

type AlertMessageParamType = {
    title?: string
    message: string
}
const useAlertMessageAction = () => {
    const setAppAlertMessageStore = useSetRecoilState(appAlertMessageStore)

    const openAlertMessage = (param: AlertMessageParamType) => {
        setAppAlertMessageStore((prevState) => ({
            ...prevState,
            isOpen: true,
            title: param.title ?? '',
            message: param.message,
        }))
    }
    const closeAlertMessage = () => {
        setAppAlertMessageStore((prevState) => ({
            ...prevState,
            isOpen: false,
            title: '',
            message: '',
        }))
    }

    return {
        openAlertMessage,
        closeAlertMessage,
    }
}

export default useAlertMessageAction
